$('.sustain-last-banner .t4s-row').slick({
        dots: false,
        arrows:true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 2000,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 676,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows:false,
              dots:true
            }
          }
        ]
});
$('.sustainibility .design-third-section .t4s-row').slick({
    dots: true,
    arrows:true,
    infinite: true,
    speed: 300,
    slidesToShow: 3.8,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 2000,
        settings: "unslick"
      },
      {
        breakpoint: 600,
        settings: {
          arrows:false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
});
$('.collection-slider-wrapper').slick({
        dots: true,
        arrows:true,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
          {
            breakpoint: 8000,
            settings: {
              slidesToShow: 7.6,
              slidesToScroll: 1,
              infinite: false,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              arrows:false,
              slidesToShow: 4.3,
              slidesToScroll: 1
            }
          }
        ]
});
 $('.review-section-content').slick({
    dots: true,
    arrows:true,
    infinite: false,
    speed: 300,
    slidesToShow: 3.8,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 2000,
        settings: {
          slidesToShow: 3.8,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          arrows:false,
          slidesToShow: 1.5,
          slidesToScroll: 1
        }
      }
    ]
});
$('.design-third-section .t4s-row').slick({
    dots: true,
    arrows:true,
    infinite: true,
    speed: 300,
    slidesToShow: 3.8,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 2000,
        settings: "unslick"
      },
      {
        breakpoint: 600,
        settings: {
          arrows:false,
          slidesToShow: 1.68,
          slidesToScroll: 1
        }
      }
    ]
});
$('.design-fourth-section .t4s-row').slick({
    dots: true,
    arrows:true,
    infinite: false,
    speed: 300,
    slidesToShow: 3.8,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 2000,
        settings: "unslick"
      },
      {
        breakpoint: 600,
        settings: {
          arrows:false,
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      }
    ]
});
$('.design-consult-service .t4s-container .t4s-row').slick({
    dots: true,
    arrows:true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 2000,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          arrows:true,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true
        }
      }
    ]
});
$('.deisgn-consult-slider .t4s-container .t4s-row').slick({
    dots: true,
    arrows:true,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 2000,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          arrows:false,
          slidesToShow: 1.6,
          slidesToScroll: 1,
          adaptiveHeight: true
        }
      }
    ]
});
 $('.review-slider-box').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  arrows: true,
  asNavFor: '.review-slider-nav',
  responsive: [
      {
        breakpoint: 600,
        settings: {
          arrows:false,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots:true
        }
      }
    ]
});
$('.review-slider-nav').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.review-slider-box',
  dots: false,
  focusOnSelect: true
});
$('.out-slider-wrapper').slick({
    dots: false,
    arrows:false,
    infinite: false,
    slidesToShow: 5.8,
    draggable:true,
    autoplay: true,
    autoplaySpeed: 2000,
    swipe:true,
    responsive: [
      {
        breakpoint: 2000,
        settings: {
          slidesToShow: 5.8,
          draggable:true,
          swipe:true
        }
      },
      {
        breakpoint: 600,
        settings:"unslick"
      }
    ]
});
$('.story-usp-slider').slick({
        dots: true,
        arrows:false,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 2000,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1.4,
              slidesToScroll: 1
            }
          }
        ]
});
$('.slider-image-text-section').slick({
        dots: true,
        arrows:true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 2000,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows:false,
            }
          }
        ]
});


$('.the_alankaram_experience .design-second-section .t4s-container .t4s-row').slick({
    dots: true,
    arrows:true,
    infinite: false,
    speed: 300,
    slidesToShow: 3.8,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 2000,
        settings: "unslick"
      },
      {
        breakpoint: 600,
        settings: {
          arrows:false,
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      }
    ]
});